/**
 * Подтверждение «опасных» действий менеджера (approve, delete и т.п.).
 *
 * Делегирует глобальному Alpine-диалогу (resources/views/components/confirmation-dialog.blade.php
 * + resources/js/features/dialogs/confirmation.js). Использует native <dialog>,
 * который сам себя центрирует через showModal().
 *
 * Старая custom-модалка #confirmSendCalculationModal в userrequest.blade.php
 * больше не показывается (оставлена в DOM для совместимости с inline-скриптами).
 *
 * API:
 *   showConfirmModal(message, callback)
 *   closeConfirmModal()
 */

export function showConfirmModal(message, callback) {
    if (typeof window.confirmAction === 'function') {
        window.confirmAction(message, callback);
        return;
    }
    // Fallback: если глобальный confirm-dialog ещё не загружен.
    if (window.confirm(message) && typeof callback === 'function') callback();
}

export function closeConfirmModal() {
    if (window.Alpine?.store('confirmDialog')) {
        window.Alpine.store('confirmDialog').cancel();
    }
}

export function initConfirmModal() {
    // Глобальный API для обратной совместимости с inline-скриптами в Blade.
    window.closeConfirmModal = closeConfirmModal;
}
